export default {
  'Comparison.title': 'Comparison',
  'Comparison.noData': "You haven't added any products yet",
  'Comparison.noTopics': 'Not enough topics',
  'Comparison.chooseMoreTopics': 'Please choose another items',
  'Comparison.chooseButton': 'Choose items',
  'Comparison.chooseTopics': 'Choose topics',
  'Comparison.clearAll': 'Clear all',
}
